import { createClient } from 'microcms-js-sdk';
import { Blog } from '../types/blog';
import { News } from '../types/news';

const createConfiguredClient = (serviceDomain?: string, apiKey?: string) => {
  return serviceDomain && apiKey
    ? createClient({
        serviceDomain,
        apiKey,
      })
    : null;
};

const blogClient = createConfiguredClient(
  process.env.REACT_APP_MICROCMS_BLOG_SERVICE_DOMAIN,
  process.env.REACT_APP_MICROCMS_BLOG_API_KEY,
);

const newsClient = createConfiguredClient(
  process.env.REACT_APP_MICROCMS_NEWS_SERVICE_DOMAIN,
  process.env.REACT_APP_MICROCMS_NEWS_API_KEY,
);

export const isMicroCMSConfigured = Boolean(blogClient || newsClient);

export const getBlogs = async () => {
  if (!blogClient) {
    return [] as Blog[];
  }

  const response = await blogClient.getList<Blog>({
    endpoint: 'blogs',
    queries: {
      orders: '-publishedAt',
      limit: 12,
    },
  });

  return response.contents;
};

export const getBlogById = async (id: string) => {
  if (!blogClient) {
    return null;
  }

  return blogClient.getListDetail<Blog>({
    endpoint: 'blogs',
    contentId: id,
  });
};

export const getNews = async () => {
  if (!newsClient) {
    return [] as News[];
  }

  try {
    const response = await newsClient.getList<News>({
      endpoint: 'news',
      queries: {
        orders: '-publishedAt',
        limit: 12,
      },
    });

    return response.contents;
  } catch (error) {
    console.error('Failed to fetch news', error);
    return [] as News[];
  }
};

export const getNewsById = async (id: string) => {
  if (!newsClient) {
    return null;
  }

  try {
    return await newsClient.getListDetail<News>({
      endpoint: 'news',
      contentId: id,
    });
  } catch (error) {
    console.error('Failed to fetch news detail', error);
    return null;
  }
};
